@if (closeable) {
  <lib-dialog-layout-inner-x (close)="dialogRef.close()" [title]="'auth.session_expired' | transloco">
    <ng-template #content>
      <p>{{ 'auth.your_session_expired' | transloco }}</p>
    </ng-template>
    <ng-template #actions>
      <button (click)="dialogRef.close()" class="btn btn-primary">
        <span inlineSVG="/icons/icon-arrow-current-color.svg"></span>
        {{ 'auth.signin' | transloco }}
      </button>
    </ng-template>
  </lib-dialog-layout-inner-x>
}

@if (!closeable) {
  <div class="dialog-panel" (close)="dialogRef.close()">
    <h1>
      {{ 'auth.session_expired' | transloco }}
    </h1>
    <p>{{ 'auth.your_session_expired_from_origin' | transloco }}</p>
  </div>
}
